import React from 'react';
import { NavLink } from "react-router-dom";
import { useDocumentTitle } from "usehooks-ts";
import { msg } from "src/app/msg";
import { msgs } from "nood-comp/src/locale/msgs";
import Tag from "nood-comp/src/comp/ui/tag/Tag";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
import Table from "nood-comp/src/comp/data/table/Table";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
import * as stylex from "@stylexjs/stylex";
export default function SignupRequests(props) {
  useDocumentTitle(msg.title(msgs.many(msg.signuprequest)));
  var __derive_color = function __derive_color(status) {
    var _statuses$status;
    var statuses = {
      'NEW': '#a2b8d1',
      'INVALID': '#de7171',
      'USED': '#B4CFB0',
      'EMAIL_SENT': '#EEC373'
    };
    return (_statuses$status = statuses[status]) !== null && _statuses$status !== void 0 ? _statuses$status : 'var(--shade-10)';
  };
  return /*#__PURE__*/React.createElement(Table, {
    data_source: "/request_invites",
    paging: {
      sorters: [{
        property: "created_on",
        isAsc: false
      }]
    },
    cols: [{
      label: 'Username',
      width: 120,
      icon: "tag",
      filterType: 'text',
      filterTextfieldWidth: 120,
      content: function content(row, idx) {
        return /*#__PURE__*/React.createElement(NavLink, {
          to: queryStringMod({
            "do": "view",
            id: row.id
          })
        }, row.username);
      }
    }, {
      label: 'Org Name',
      property: 'display_name',
      filterType: 'text',
      icon: 'user'
    }, {
      label: 'Email Address',
      property: 'email_address'
    }, {
      label: 'Status',
      width: 120,
      content: function content(row, idx) {
        return /*#__PURE__*/React.createElement(Tag, {
          value: row.status,
          color: __derive_color(row.status)
        });
      }
    }, {
      label: '',
      width: 50,
      content: function content(row, idx) {
        return /*#__PURE__*/React.createElement(ElapsedTime, {
          datetime: row.created_on
        });
      }
    }]
  });
}

//@ts-ignore